module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_2-60eb0d6da9cb2b68994bafbc7c5a514a.png";